import { z } from "zod";

export const PersonResponseSchema = z.object({
  Id: z.number(),
  LoaPortalRequestId: z.number().or(z.null()).optional(),
  RequestId: z.number().or(z.null()).optional(),
  SapAgreementNumber: z.string(),
  SupplierId: z.string(),
  WorkerEidUnifiedNumber: z.string(),
  WorkerEmiratesId: z.string(),
  WorkerFirstName: z.string(),
  WorkerLastName: z.string(),
  WorkerFullNameArabic: z.string(),
  WorkerFullNameEnglish: z.string(),
  WorkerNationality: z.string(),
  WorkerNationalityEnglish: z.string(),
  WorkerNationalityArabic: z.string(),
  WorkerPassportNumber: z.string(),
  WorkerJobTitle: z.string(),
  WorkerJobTitleArabic: z.string(),
  ResidencyAr: z.string().or(z.null()).optional(),
  CompanyAr: z.string().or(z.null()).optional(),
  PlaceOfIssuingResidencePermit: z.string(),
  WorkerMedicalFitnessStatus: z.boolean(),
  WorkerMedicalFitnessExpirationDate: z.string().or(z.null()).optional(),
  WorkerHseStatus: z.boolean(),
  WorkerHseExpirationDate: z.string().or(z.null()).optional(),
  WorkerToxicGasStatus: z.boolean(),
  WorkerToxicGasExpirationDate: z.string().or(z.null()).optional(),
  WorkerOnboardingStatus: z.number(),
  WorkerOnboardingStatusComments: z.string(),
  CreationDate: z.string().or(z.null()).optional(),
  LastUpdateDate: z.string().or(z.null()).optional(),
  Note: z.string().or(z.null()).optional(),
  PlaceOfIssuingResidencePermitArabic: z.string().or(z.null()).optional(),
  Value: z.string().optional(),
});

export interface PersonnelsPayload {
  email: string;
  agreementNumber: string;
  supplierId: string;
}

export interface PersonnelsByReferenceNumberPayload {
  email: string;
  referenceNumber: string;
  isSelected?: boolean;
  isDraft?: boolean;
}

export interface PersonnelsNotFlatResponse {
  LoaWorkers: Personnels;
}

export const PersonnelsResponseSchema = z.array(PersonResponseSchema);

export type Person = z.infer<typeof PersonResponseSchema>;

export type Personnels = z.infer<typeof PersonnelsResponseSchema>;
